import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuggestedTitlesComponent } from './suggested-titles/suggested-titles.component';
import { MatChipsModule as MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule as MatTooltipModule } from "@angular/material/tooltip";
import { EmailCampaignAssistantComponent } from './email-campaign-assistant/email-campaign-assistant.component';
import { ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule as MatAutocompleteModule } from "@angular/material/autocomplete";

@NgModule({
    declarations: [SuggestedTitlesComponent, EmailCampaignAssistantComponent],
    imports: [
        CommonModule,
        MatChipsModule,
        MatIconModule,
        MatTooltipModule,
        ReactiveFormsModule,
        MatAutocompleteModule
    ],
    exports: [SuggestedTitlesComponent, EmailCampaignAssistantComponent]
})
export class OpenaiModule { }
